var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"user-info",attrs:{"to":{name: 'ViewUser', params: {id: _vm.user.id}}}},[_c('UserAvatar',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }